import { TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UI } from '../../../../constants';
import { TLocalesKeys as K } from '../../../../types';
import { useUserAction } from '../../../common/hooks/useUserAction';
import { chatActions } from '../../../common/reducers/chat';
import { ChatScrollToPositions } from '../../../common/reducers/types';
import { selectIsLocked } from '../../../common/selectors/chat';

export interface Props {
  id: string;
  nodeId: string;
  disabled: boolean;
}

export const ChangeButton: FC<Props> = ({ id, nodeId, disabled }) => {
  const isLocked = useSelector(selectIsLocked);
  const emit = useUserAction(UI.CHANGE, id);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const clickHandler = () => {
    emit({ nodeId });
    dispatch(chatActions.changeMessage());
    dispatch(chatActions.scrollTo(ChatScrollToPositions.Bottom));
  };

  return (
    <TextButton
      dataHook="change"
      onClick={!isLocked ? clickHandler : undefined}
      disabled={disabled}
      aria-describedby={id}
      weight="normal"
      size="small"
    >
      {t<K>('change_btn_label')}
    </TextButton>
  );
};
